var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrossClose = function SvgCrossClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.19,
    height: 22.19,
    viewBox: "0 0 22.19 22.19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_849",
    "data-name": "Union 849",
    d: "M6.378,14.234,6.622,8.6l-5.81.237a.959.959,0,0,1-1.03-1A1.172,1.172,0,0,1,.9,6.744l5.81-.237L6.956.869A1.175,1.175,0,0,1,8.078-.218a.96.96,0,0,1,1.031,1L8.865,6.42l5.81-.237a.958.958,0,0,1,1.031,1,1.175,1.175,0,0,1-1.122,1.089l-5.81.237-.244,5.638a1.177,1.177,0,0,1-1.122,1.089H7.363A.957.957,0,0,1,6.378,14.234Z",
    transform: "translate(21.88 10.928) rotate(135)",
    fill: "#6C6C6C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crossClose.f9d43686.svg";
export { ForwardRef as ReactComponent };